export const ROUTE_PATH = '/reconciliations-bonus-details/:details_id';

export const FEATURE_NAME = 'reconciliationPeriodBonusDetailsPage';
